import { useLingui } from "@lingui/react/macro";
import { WindowControls } from "@rakazo/ui-web";
import { useEffect, useState } from "react";
import { desktopBridge, windowChromeKind } from "../lib/desktop";

/**
 * Desktop window buttons for a frameless window. The browser has no OS window to control, so
 * it renders nothing; macOS keeps its native traffic lights.
 */
export function WindowChrome() {
  const { t } = useLingui();
  const desktop = desktopBridge();
  const kind = windowChromeKind(desktop);
  const [maximized, setMaximized] = useState(false);
  useEffect(() => {
    if (!desktop?.window?.state) return;
    let disposed = false;
    let receivedEvent = false;
    const unsubscribe = desktop.window.onStateChange?.((state) => {
      receivedEvent = true;
      if (!disposed) setMaximized(state.maximized || state.fullScreen);
    });
    void desktop.window.state().then(
      (state) => {
        if (!disposed && !receivedEvent) setMaximized(state.maximized || state.fullScreen);
      },
      () => undefined,
    );
    return () => {
      disposed = true;
      unsubscribe?.();
    };
  }, [desktop]);

  if (kind === "spacer") {
    return <div className="h-3 w-[72px] shrink-0" aria-hidden="true" />;
  }
  if (kind === "darwin") {
    return <div className="app-drag h-3 w-[72px] shrink-0" aria-hidden="true" />;
  }
  return (
    <WindowControls
      maximized={maximized}
      minimizeLabel={t`Minimize`}
      maximizeLabel={t`Maximize`}
      restoreLabel={t`Restore`}
      closeLabel={t`Close`}
      onMinimize={() => void desktop?.window?.minimize()}
      onToggleMaximize={() => void desktop?.window?.toggleMaximize()}
      onClose={() => void desktop?.window?.close()}
    />
  );
}
